export default __webpack_public_path__ + "static/media/tradex.eee10a54.jpg";